module.exports = __webpack_public_path__ + "img/cyberport.94f9a657.png";